import React from 'react';
import './notific-header-component.css';


export const NotificComponentHeader = () => (
	<React.Fragment>
		{/*
		<img
			src={`/imgs/bell.png`}
			className={'notific-header-component-icon'}
		/>
		*/}
	</React.Fragment>
);
